"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class PhoneInputValidator {
  validatePattern = value => {
    const regexPattern = /^\+\d\d \d\d \d\d\d \d\d \d\d( \d+)?$/;
    return regexPattern.test(value);
  };
}
const phoneInputValidator = new PhoneInputValidator();
var _default = exports.default = phoneInputValidator;